<template>
  <div
    class="dashboard flex flex-col xl:flex-row justify-between w-full py-4 md:px-12 md:py-16"
  >
    <dashboard-data :class="{ 'pr-6': userType === 'admin' && $mq === 'xl' }" />
    <projects-overview-module
      v-if="userType === 'admin'"
      class="xl:pl-6 pt-1 md:pt-0 md:max-w-xs xl:mt-0"
      :class="{
        'mt-6': !(userType === 'admin' && $mq === 'sm')
      }"
    />
  </div>
</template>

<script>
// @ is an alias to /src
import DashboardData from "../components/dashboard/DashboardData";
import ProjectsOverviewModule from "../components/dashboard/ProjectsOverviewModule";

export default {
  name: "Dashboard",
  components: { ProjectsOverviewModule, DashboardData },
  computed: {
    userType() {
      return this.$store.state.userType;
    }
  }
};
</script>
